(function() {
    'use strict';
 
 a3_pilot_reports.factory('GenericService', GenericService);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name GenericService
    * @description 
    *    Generic add, edit or remove
    * @ngInject
    */
 function GenericService(localStorageMD5Service) {

		var objectType = null ;
		var objectCallback = null;
		
		var service = 
		{
			initiate : initiate,
			get : get,
			getOne : getOne,
			list : list,
			save : save,
			saveOne : saveOne,
			saveAll : saveAll,
			remove : remove,
			removeAll : removeAll,
			add : add,
			constructor : constructor,
			fromObject : fromObject,
			fromObjectList : fromObjectList
		};

        /**
         * initiate type and callback
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @memberof GenericService
         */
		function initiate(type,callback){
			objectType = type;
			objectCallback = callback;
		}
		
        /**
         * Get the requested object
         * @memberof GenericService
         * @param {number} id The unique identifier
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} result
         */
		function get(id,type,callback){
			initiate(type,callback);
			var objects = list(type,callback);
			if (objects == null)
				return null;
		
			var result = null;
		
			var arrayLength = objects.length;
			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() == id)	{
					result = objects[i];
					break;
				}
			}
			
			return result;
		}

        /**
         * Get all the objects
         * @memberof GenericService
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {array} objectList
         */
		function list(type,callback){
			initiate(type,callback);
			var objects = localStorageMD5Service.get(objectType);
			return fromObjectList(objects,callback);
		}

     
        /**
         * Get the unique object of this storage
         * @memberof GenericService
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @return {object} object
         */
		function getOne(type,callback){
			initiate(type,callback);
			var object = localStorageMD5Service.get(objectType);
			return fromObject(object,callback);
		}
				
		function saveOne(obj,type,callback){
			localStorageMD5Service.set(type,obj);
		}

		function save(object,type,callback){
			initiate(type,callback)
			var objects = list(type,callback);
			var updatedobject = fromObject(object,callback);

			var arrayLength = objects.length;
			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() == updatedobject.GetId())	{
					objects[i] = updatedobject;
					break;
				}
			}
		
		saveAll(objects,type,callback);
		}

		function saveAll(objects,type,callback){
			initiate(type,callback);
			localStorageMD5Service.set(objectType,objects);
		}

		function remove(Id,type,callback){
			initiate(type,callback);
			var objects = list(type,callback);
			var newObjects = [];
				
			var arrayLength = objects.length;
			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() != Id)	{
					newObjects.push(objects[i])
				}
			}
		
			saveAll(newObjects,type,callback);
		}

		function removeAll(type,callback){
			initiate(type,callback);
			localStorageMD5Service.remove(objectType);
		}
		
		function add(obj,type,callback){
			var objects = list(type,callback);
			objects.push(obj);
			saveAll(objects,type,callback);
		}
		
		function constructor(callback){
			var object = new callback();
			return object;
		}
		
		function fromObject(obj,callback){
			if (obj==null) return null;
			var object = new callback();
			angular.extend(object, obj);
			return object;
		}
		
	 function fromObjectList(objList,callback) {
		if (objList==null)
			return [];
		
		var arrayLength = objList.length;
		var objects = new Array();
		
		for (var i = 0; i < arrayLength; i++) {
			objects.push(fromObject(objList[i],callback));
		}
		
		return objects;
	}

	return service;
	}

 
 })();   